import React, { useState } from 'react';
import { calculateElementEnergy } from '../utils/dataManager';

const ElementForm = ({ onCalculate }) => {
  const [formData, setFormData] = useState({
    name: '',
    birthdate: '',
    zodiacSign: ''
  });

  const [errors, setErrors] = useState({});

  const zodiacSigns = [
    '白羊座', '金牛座', '双子座', '巨蟹座', 
    '狮子座', '处女座', '天秤座', '天蝎座', 
    '射手座', '摩羯座', '水瓶座', '双鱼座'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // 清除错误
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = '请输入姓名';
    }
    
    if (!formData.birthdate) {
      newErrors.birthdate = '请选择出生日期';
    }
    
    if (!formData.zodiacSign) {
      newErrors.zodiacSign = '请选择星座';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validate()) {
      try {
        // 计算五行能量
        const result = await calculateElementEnergy(formData.birthdate, formData.name);
        onCalculate(result, formData);
      } catch (error) {
        console.error('计算五行能量出错:', error);
        alert('计算过程中出现错误，请重试');
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="card p-6">
      <h2 className="text-xl font-semibold mb-4 text-center">五行能量计算</h2>
      
      <div className="mb-4">
        <label htmlFor="name" className="block text-gray-700 mb-2">姓名</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={`w-full px-3 py-2 border rounded-md ${errors.name ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-primary`}
          placeholder="请输入您的姓名"
        />
        {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
      </div>
      
      <div className="mb-4">
        <label htmlFor="birthdate" className="block text-gray-700 mb-2">出生日期</label>
        <input
          type="date"
          id="birthdate"
          name="birthdate"
          value={formData.birthdate}
          onChange={handleChange}
          className={`w-full px-3 py-2 border rounded-md ${errors.birthdate ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-primary`}
        />
        {errors.birthdate && <p className="text-red-500 text-sm mt-1">{errors.birthdate}</p>}
      </div>
      
      <div className="mb-6">
        <label htmlFor="zodiacSign" className="block text-gray-700 mb-2">星座</label>
        <select
          id="zodiacSign"
          name="zodiacSign"
          value={formData.zodiacSign}
          onChange={handleChange}
          className={`w-full px-3 py-2 border rounded-md ${errors.zodiacSign ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-primary`}
        >
          <option value="">请选择您的星座</option>
          {zodiacSigns.map(sign => (
            <option key={sign} value={sign}>{sign}</option>
          ))}
        </select>
        {errors.zodiacSign && <p className="text-red-500 text-sm mt-1">{errors.zodiacSign}</p>}
      </div>
      
      <button
        type="submit"
        className="w-full bg-gradient-to-r from-primary to-secondary text-white py-2 rounded-md hover:opacity-90 transition-opacity"
      >
        计算能量
      </button>
    </form>
  );
};

export default ElementForm;